import FingerprintJS from '@fingerprintjs/fingerprintjs';

export const getStableDeviceId = async () => {
  const fp = await FingerprintJS.load();
  const result = await fp.get();
  // console.log("Device ID:", result.visitorId);

  // Store device ID in localStorage for reuse
  localStorage.setItem('deviceId', result.visitorId);

  return result.visitorId;
};